import React, { Component } from 'react';
import { withRouter } from 'react-router';
import AuthService from './services/AuthService'
import './css/Login.css';

class Login extends Component {

  constructor(props){
    super(props);
    this.authApi = new AuthService()
  }

  state = {
    user:"",
    username: "",
    password: "",
    newPassword: "",
    nickname: "",
    error:"",
    completeNewPasswordError:"",
    retypeNewPassword: ""
  }

  handleChange(event, name) {
    this.setState({
      [name]: event.target.value
    });
  }

  handleLoginSubmit(event){
    event.preventDefault();

    let username = this.state.username;
    let password = this.state.password;

    this.authApi.signIn(username, password)
      .then(
        (user) => {
          if(typeof user !== 'undefined'){
            this.setState({
              user:user
            });
            if(user.challengeName === "NEW_PASSWORD_REQUIRED"){
              this.setState({
                error: "初回ログインの場合は、新しいパスワードとニックネームを設定してください。"
              })
            }else{
              this.props.history.push('/');
            }
          }else{
            this.setState({
              error: "ログインに失敗しました。"
            })
          }
        }
      );
    this.setState({
      password:""
    });
  }

  handleCompleteSubmit(event){
    event.preventDefault();

    let user = this.state.user;
    let newPassword = this.state.newPassword;
    let retypeNewPassword = this.state.retypeNewPassword;
    let attributes = {nickname: this.state.nickname};

    if(newPassword === retypeNewPassword){
      this.authApi.completeNewPassword(user, newPassword, attributes)
      .then(
        user => {

          if(typeof user.username !== 'undefined'){

            this.props.history.push('/main');

          }else{

            if(user.code === "InvalidPasswordException"){
              this.setState({
                completeNewPasswordError: "パスワードは８文字以上で、大文字、小文字を含んで設定してください。"
              })
            }

            if(user.code === "InvalidParameterException"){
              this.setState({
                completeNewPasswordError: "ニックネームを入力してください。"
              })
            }

            if(user === "Password cannot be empty"){
              this.setState({
                completeNewPasswordError: "パスワードを入力してください。"
              })
            }

          }

        }
      )
    }else{
      this.setState({
        completeNewPasswordError: "パスワードが一致しません。"
      })
    }


  }

  render() {
    const loginDom = (
      <div className="login">
        <div className="login-page">
          <div className="form">
            <img border="0" src="images/manekineko.png" width="64" height="64" alt="logo" />
            <h2 style={{marginBottom: 30, fontFamily:'Nico Moji'}}>Manekineko</h2>

            <form className="login-form" onSubmit={(event) => this.handleLoginSubmit(event)}>
              <input type="text" placeholder="username" value={this.state.username} onChange={(event) => this.handleChange(event, "username")}/>
              <input type="password" placeholder="password" autoComplete="off" value={this.state.password} onChange={(event) => this.handleChange(event, "password")}/>
              <p>{this.state.error}</p>
              <button type="submit">login</button>
              {/*<p className="message">Not registered? <a href="#">Create an account</a></p>*/}
            </form>
          </div>
        </div>
      </div>
    );

    const completeNewPasswordDom = (
      <div className="login">
        <div className="login-page">
          <div className="form">
            <form className="login-form" onSubmit={(event) => this.handleCompleteSubmit(event)}>
              <input type="text" placeholder="Nickname(必須)" value={this.state.nickname} onChange={(event) => this.handleChange(event, "nickname")}/>
              <input type="password" placeholder="New Password" autoComplete="off" value={this.state.newPassword} onChange={(event) => this.handleChange(event, "newPassword")}/>
              <input type="password" placeholder="Retype New Password" autoComplete="off" value={this.state.retypeNewPassword} onChange={(event) => this.handleChange(event, "retypeNewPassword")}/>
              <p>{this.state.error}</p>
              <p>{this.state.completeNewPasswordError}</p>
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    );

    if(!this.state.user){
      return loginDom;
    }else{
      return completeNewPasswordDom;
    }

  }
}

export default withRouter(Login);
